// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .spinner {
    width: 100%;
    height: 70px;
    display: "flex";
    justify-content: "center";
    align-items: "center";
    background-color: cornflowerblue;
    margin-left: auto;
    margin-right: auto;
} */

.spinner {
    /* background-color: lightskyblue; */
    width: auto;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -50px 0 0 -50px;
    z-index: 2000;
    text-align: center;
    /* color:darkblue;
    font-size: 1.2em; */
}

.spinner-2 {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -50px 0 0 -50px;
    z-index: 100;
}

`, "",{"version":3,"sources":["webpack://./src/components/LoadingSpinner.css"],"names":[],"mappings":"AAAA;;;;;;;;;GASG;;AAEH;IACI,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB;uBACmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,YAAY;AAChB","sourcesContent":["/* .spinner {\n    width: 100%;\n    height: 70px;\n    display: \"flex\";\n    justify-content: \"center\";\n    align-items: \"center\";\n    background-color: cornflowerblue;\n    margin-left: auto;\n    margin-right: auto;\n} */\n\n.spinner {\n    /* background-color: lightskyblue; */\n    width: auto;\n    height: auto;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin: -50px 0 0 -50px;\n    z-index: 2000;\n    text-align: center;\n    /* color:darkblue;\n    font-size: 1.2em; */\n}\n\n.spinner-2 {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin: -50px 0 0 -50px;\n    z-index: 100;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
